import AppDispatcher from "../../../flux/dispatcher/dispatcher";
import Constant from "../Constants";
import restClient from "../../MainFrame/action/APIClient";
import { message } from "antd";

var UpdateBlockedDomainAction = function () {};

UpdateBlockedDomainAction.prototype = {
  updateRestrictedDomainDetails: function (data) {
    restClient.integrationsupdate(data, function (error, response) {
      if (error) {
        //message.success(error.message, 2);
        error && error.data && error.data.message && message.error(error.data.message,2)
        AppDispatcher.dispatch({
          actionType: Constant.DELETE_BLOCKED_PUBLIC_EMAIL_DOMAIN,
          data: error,
        });
      } else {
        response && (response["status"] = 200) ;
        response.message&&message.success(response.message,2)
        AppDispatcher.dispatch({
          actionType: Constant.DELETE_BLOCKED_PUBLIC_EMAIL_DOMAIN,
          data: response,
        });
      }
    });
  },
};

export default new UpdateBlockedDomainAction();
